export class Perfil {
    email: string;
    nm_Nome: string;
    nm_Senha: string;
    is_Rpl: number;
    is_Rus: number;
    tp_Nivel_Master: boolean;
}